// this file is automatically generated by git.version.ts script
export const versions = {
  version: '0.0.0',
  revision: '1e10bb2',
  branch: 'TDEBT-2546',
  buildDateTime: '10/26/2023, 12:19:11 PM UTC'
};
